import React, { createContext, useContext, useState, useEffect } from 'react';
import safeStorage from '../utils/safeStorage';

const ThemeContext = createContext();
export const useTheme = () => useContext(ThemeContext);

export const ThemeProvider = ({ children }) => {
  const [darkMode, setDarkMode] = useState(() => {
    try {
      const saved = safeStorage.getItem('dreamyTheme');
      if (saved) return saved === 'dark';
      // Respect OS preference on first visit
      return window.matchMedia?.('(prefers-color-scheme: dark)').matches ?? false;
    } catch { return false; }
  });

  useEffect(() => {
    const theme = darkMode ? 'dark' : 'light';
    document.documentElement.setAttribute('data-theme', theme);
    // Set root background immediately to prevent flash during navigation
    document.documentElement.style.background = darkMode ? '#0f0b1e' : '';
    try { safeStorage.setItem('dreamyTheme', theme); } catch {}
  }, [darkMode]);

  const toggleDarkMode = () => setDarkMode(d => !d);

  return (
    <ThemeContext.Provider value={{ darkMode, toggleDarkMode }}>
      {children}
    </ThemeContext.Provider>
  );
};
